import { render } from "./Admin.Tests.Header.vue?vue&type=template&id=7a72a378&scoped=true"
import script from "./Admin.Tests.Header.vue?vue&type=script&lang=js"
export * from "./Admin.Tests.Header.vue?vue&type=script&lang=js"

import "./Admin.Tests.Header.vue?vue&type=style&index=0&id=7a72a378&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a72a378"]])

export default __exports__